import {useEffect, useRef, useState} from 'react';
import {ThemeProvider} from 'styled-components';
import {BrowserRouter} from "react-router-dom";
import axios from "axios";
import {isEmpty} from "lodash-es";

import '../src/i18n'
import Whole__Page from "./Pages/7Studio";
import Animation from "./Pages/Components/Animation";
import {ANIMATION__CONTEXT, Local_Data} from "./Context";
import {FALLBACK_PRODUCTS, Local__Data__Value} from "./PageValues";
import {DARK_THEME} from "./Styles/theme";
import GlobalStyle from "./Styles/GlobalStyle";

const SITE_CONFIG_URL = 'https://pub-5c03924c06b5439684cebaa3f4aba397.r2.dev/pageContent.json'

const MAX_CONFIG_RETRIES = 3

function App() {

    const [localData, setLocalData] = useState<any>(Local__Data__Value)

    const [animation, setAnimation] = useState(false)

    const requestCount = useRef<number>(0)

    const onGetSiteConfig = async () => {
        try {
            requestCount.current += 1
            const response = await axios.get(SITE_CONFIG_URL)
            setLocalData((state: any) => ({
                ...state,
                ...response.data,
                Products: response.data.productList ?? {},
                isLoadingProducts: false
            }))
        } catch (error) {
            if (requestCount.current < MAX_CONFIG_RETRIES) {
                onGetSiteConfig()
                return
            }
            // Keep the offer list usable even when the remote config is down.
            setLocalData((state: any) => ({
                ...state,
                Products: isEmpty(state.Products) ? FALLBACK_PRODUCTS : state.Products,
                isLoadingProducts: false
            }))
        }
    }

    useEffect(() => {
        if (isEmpty(localData.Products)) {
            onGetSiteConfig()
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <Local_Data.Provider value={[localData, setLocalData]}>
            <ANIMATION__CONTEXT.Provider value={[animation, setAnimation] as any}>
                <ThemeProvider theme={DARK_THEME}>
                    <GlobalStyle/>
                    <BrowserRouter>
                        <Whole__Page/>
                        <Animation/>
                    </BrowserRouter>
                </ThemeProvider>
            </ANIMATION__CONTEXT.Provider>
        </Local_Data.Provider>
    );
}

export default App;
